/**
 * PortalInsuranceSettings - Insurance form settings for Customer Portal
 */
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import InsuranceFormsSettings from '@/components/settings/InsuranceFormsSettings';

const PortalInsuranceSettings = () => {
  const navigate = useNavigate();

  return (
    <div className="p-8 max-w-4xl">
      <Button variant="ghost" className="mb-4 -ml-2" onClick={() => navigate('/portal-settings')}>
        <ArrowLeft className="h-4 w-4 mr-2" /> Zurück
      </Button>
      
      <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2 mb-6">
        <FileText className="h-6 w-6 text-cyan-500" /> Krankenkassenformulare
      </h1>

      <InsuranceFormsSettings />
    </div>
  );
};

export default PortalInsuranceSettings;
